export default __webpack_public_path__ + "aeaa8390d2ef7f95cf2d289763b6eaaf.png";